import { Component } from "react"
import PropTypes from "prop-types"

import ingredientValueTypes from "partners/components/shared/ingredient_value_types"
import { StatusRow } from "./table_components"

export default class Ingredient extends Component {
  renderAttributes() {
    const { type, ingredient, feedbackItems = {} } = this.props
    let attributes = [
      {
        key: `${type}-ingredient-output-name-${ingredient.id}`,
        name: "Label",
        value: ingredient.name,
        required: true,
        fieldName: "name",
        transform: value => <strong>{value}</strong>,
      },
      {
        key: `${type}-ingredient-output-note-${ingredient.id}`,
        name: "Description",
        value: ingredient.note,
        fieldName: "note",
      },
      {
        key: `${type}-ingredient-output-slug-${ingredient.id}`,
        name: "Slug",
        value: ingredient.slug,
        required: true,
        fieldName: "slug",
      },
      {
        key: `${type}-ingredient-output-value_type-${ingredient.id}`,
        name: "Type",
        value: ingredient.value_type,
        fieldName: "value_type",
        transform: value => ingredientValueTypes[value].label,
      },
    ]

    if (ingredient.value_type === "query") {
      attributes = attributes.concat([
        {
          key: "${type}-ingredient-output-sub-query",
          name: "Query",
          value: ingredient.target_query_name,
          fieldName: "target_query_name",
        },
      ])
    }

    if (
      ["string", "image_url", "file_url", "web_url"].includes(
        ingredient.value_type
      )
    ) {
      attributes = attributes.concat([
        {
          key: `${type}-ingredient-output-example-${ingredient.id}`,
          name: "Example",
          value: ingredient.example,
          required: true,
          fieldName: "example",
        },
      ])
    }

    return attributes.map(item => {
      item.feedback = feedbackItems[item.fieldName]
      item.pathObjs = [...this.props.pathObjs, ingredient.id, item.fieldName]
      item.diff = this.props.changes.find(
        diff => diff.data && diff.data.property === item.fieldName
      )
      return this.props.tableRow(item)
    })
  }

  render() {
    return (
      <table
        key={`${this.props.type}-output-${this.props.ingredient.slug}-${this.props.ingredient.id}`}
        className="subtable"
      >
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.renderAttributes()}
        </tbody>
      </table>
    )
  }
}

Ingredient.propTypes = {
  type: PropTypes.oneOf(["trigger", "query"]).isRequired,
  diffStyle: PropTypes.string.isRequired,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  pathObjs: PropTypes.array.isRequired,
  ingredient: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
}
